<template>
	<vx-card no-shadow>
		<template slot="no-body">
			<div class="flex items-center justify-between">
				<vs-list class="border border-solid d-theme-border-grey-light">
					<vs-list-item icon="group" :title="propertyNamesLocal.total_vehicles">
						<span class="text-success text-lg font-semibold">
							{{ standardOutput.total_vehicles }}
						</span>
					</vs-list-item>
					<vs-list-item icon="how_to_reg" :title="propertyNamesLocal.total_routed_vehicles"
						><span class="text-success text-lg font-semibold">
							{{ standardOutput.total_routed_vehicles }}</span
						></vs-list-item
					>
					<vs-list-item icon="person_add_disabled" :title="propertyNamesLocal.total_not_routed_vehicles"
						><span class="text-danger text-lg">{{
							standardOutput.total_not_routed_vehicles
						}}</span></vs-list-item
					>
				</vs-list>

				<vs-list class="m-1 border border-solid d-theme-border-grey-light">
					<vs-list-item icon="location_on" :title="propertyNamesLocal.total_visit_points"
						><span class="text-success text-lg font-semibold">
							{{ standardOutput.total_visit_points }}</span
						></vs-list-item
					>
					<vs-list-item icon="where_to_vote" :title="propertyNamesLocal.total_routed_visit_points">
						<span class="text-success text-lg font-semibold">
							{{ standardOutput.total_routed_visit_points }}</span
						></vs-list-item
					>
					<vs-list-item icon="location_off" :title="propertyNamesLocal.total_not_routed_visit_points"
						><span class="text-danger text-lg">{{
							standardOutput.total_not_routed_visit_points
						}}</span></vs-list-item
					>
				</vs-list>

				<vs-list class="border border-solid d-theme-border-grey-light">
					<vs-list-item icon="access_time" :title="propertyNamesLocal.total_time_all_routes">
						{{ standardOutput.total_time_all_routes }}
					</vs-list-item>
					<vs-list-item icon="language" :title="propertyNamesLocal.total_distance"
						>{{ standardOutput.total_distance | removeDecimals }}
						Km
					</vs-list-item>
					<vs-list-item icon-pack="feather" icon="icon-home" :title="propertyNamesLocal.deposits"
						>{{ deposits(standardOutput) }}
					</vs-list-item>
				</vs-list>
			</div>
		</template>
	</vx-card>
</template>

<script>
export default {
	props: {
		standardOutput: {
			type: Object,
		},
		propertyNames: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {};
	},
	computed: {
		propertyNamesLocal() {
			if (this.propertyNames) {
				return this.propertyNames;
			} else {
				return {
					total_vehicles: this.$t("Routing.RouteResult.TotalResources"),
					total_routed_vehicles: this.$t("Routing.RouteResult.ResourcesRouted"),
					total_not_routed_vehicles: this.$t("Routing.RouteResult.ResourcesNotRouted"),
					total_visit_points: this.$t("Routing.RouteResult.TotalVisitPoints"),
					total_routed_visit_points: this.$t("Routing.RouteResult.VisitPointsRouted"),
					total_not_routed_visit_points: this.$t("Routing.RouteResult.VisitPointsNotRouted"),
					total_time_all_routes: this.$t("Routing.RouteResult.RoutesTime"),
					total_distance: this.$t("Routing.RouteResult.TotalDistance"),
					deposits: this.$t("Deposits.Depot"),
				};
			}
		},
		deposits() {
			return function (params) {
				if (params.deposits && params.deposits.all_deposits) return params.deposits.all_deposits.length;
				else return 0;
			};
		},
	},
	filters: {
		removeDecimals(num = 0.03) {
			return num.toFixed(1);
		},
	},
};
</script>
